import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import FormField from './FormField';
import { Glyphicon, Form, ControlLabel, FormGroup, FormControl } from 'react-bootstrap';
import ReactSelect from 'react-select';

class Select extends PureComponent {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
    }

    onChange(evt) {
        this.props.field.onChange(evt);
        if (this.props.onChange) {
            this.props.onChange(evt);
        }
    }

    onBlur(evt) {
        this.props.field.onBlur(evt);
        if (this.props.onBlur) {
            this.props.onBlur(evt);
        }
    }

    render() {
        const { required, disabled, field, help, options, onChange, onBlur, label, loading, multiple, embedded, onOptionStyle, selectStyle, inputSize, labelSize, icon, onOptionLabelElement, ...rest} = this.props;
        let style = this.props.style;
        let optionValues = [];
        if (options && options.length > 0) {
            optionValues = options;
        }

        // Non editable dropdowns look like the rest of the app (react-select), not like the browser's own.
        // Listing several values at once (multiple) keeps the native control.
        const items = optionValues.map((option) => {
            const isObject = _.isPlainObject(option);
            return {
                original: isObject ? option.value : option,
                value: String(isObject ? option.value : option),
                label: isObject ? option.label : option,
                raw: option,
            };
        });

        let current = items.find(item => item.value === String(field.value));
        if (!current && (field.value === undefined || field.value === null || field.value === '')) {
            current = items[0];
        }

        let fieldRender = !multiple ? (
            <ReactSelect
                    className="ct-dropdown"
                    options={items}
                    value={current ? current.value : undefined}
                    clearable={false}
                    searchable={false}
                    disabled={disabled}
                    style={selectStyle}
                    onBlur={field.onBlur}
                    optionRenderer={onOptionStyle ? (item => (<span style={onOptionStyle(item.raw)}>{item.label}</span>)) : undefined}
                    onChange={(item) => {
                        if (!item) {
                            return;
                        }

                        this.onChange({
                            persist: () => {},
                            preventDefault: () => {},
                            target: { name: field.name, id: field.name, type: 'select-one', value: item.original },
                        });
                    }}
            />
        ) : (
            <FormControl
                    componentClass="select"
                    multiple={!!multiple}
                    onChange={this.onChange}
                    onBlur={field.onBlur}
                    value={field.value}
                    disabled={disabled}
                    style={selectStyle}
                    {...rest}>


                {optionValues.map((option, index) => {
                    let value = option;
                    let label = option;
                    if (_.isPlainObject(option)) {
                        value = option.value;
                        label = option.label;
                    }

                    let style = {};
                    if (onOptionStyle) {
                        style = onOptionStyle(option);
                    }

                    return (<option key={`${option}_${index}`} value={value} style={style}>{label}</option>);
                })}
            </FormControl>
        );

        if (icon) {
            fieldRender = (
                <Form inline>
                    <FormGroup>
                        <ControlLabel>
                            <Glyphicon glyph={icon} style={{ marginRight: 10 }} />
                        </ControlLabel>
                        {fieldRender}
                    </FormGroup>
                </Form>
            );
        }

        if (!embedded) {
            fieldRender = (
                <FormField required={required} field={field} help={help} loading={loading} label={label} style={style} inputSize={inputSize} labelSize={labelSize}>
                {fieldRender}
                </FormField>
            );
        }

        return fieldRender;
    }
}

Select.propTypes = {
    field: PropTypes.object.isRequired,
};

export default Select;
